import type { CSSProperties, ReactNode } from 'react'
import { Eyebrow } from './Eyebrow'
import { Title } from './Title'

interface PageHeaderProps {
  eyebrow?: ReactNode
  title?: ReactNode
  mark?: ReactNode
  sub?: ReactNode
  meta?: ReactNode
  className?: string
  style?: CSSProperties
  titleStyle?: CSSProperties
}

export function PageHeader({ eyebrow, title, mark, sub, meta, className, style, titleStyle }: PageHeaderProps) {
  return (
    <div className={className ? `st-head-row ${className}` : 'st-head-row'} style={style}>
      <div>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <Title text={title} mark={mark} style={titleStyle} />
        {sub && (
          <p className="st-body" style={{ fontSize: 17, maxWidth: 560 }}>
            {sub}
          </p>
        )}
      </div>
      {meta}
    </div>
  )
}
